module.exports = __webpack_public_path__ + "static/img/ECOP_5@2x.c703eb1d.png";